var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-product-detail-info",
      attrs: { "content-type": _vm.contentType },
    },
    [
      _c("h3", { staticClass: "ns-product-detail-info__title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "ns-product-detail-info__body",
        domProps: {
          innerHTML: _vm._s(_vm.content.replace("<p>&nbsp;</p>", "")),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }